export const PAGE_SECTIONS = {
  IMAGE_COPY: 'articleSectionImageCopy',
  IMAGE_PAIR_COPY: 'articleSectionImagePairCopy',
  PROMO_HERO: 'articleSectionPromoHero',
  EMAIL_MODULE: 'pageSectionEmailSignupModule',
};
